import {UserIcon} from "@pg-design/icons-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {noop} from "@pg-mono/nodash";

import {UserIconPopover} from "../components/UserIconPopover";
import {INavMiddleElement, INavRightElement} from "../Navigation";
import {appendAmplitudeCrossDomainParams} from "../utils/append_amplitude_cross_domain_params";
import {decorateUrlWithGaLinker} from "../utils/decorate_url_with_ga_linker";
import {getFullKMLink} from "../utils/get_full_km_link";
import {useUserPopover} from "./use_user_popover";

export type UseNavigationUserElementsParams = {
    kmUrl: string;
    rpUrl?: string;
    onLogin: (e: React.MouseEvent<HTMLElement>) => void;
    onLogout: (e: React.MouseEvent<HTMLElement>) => void;
    isAuthenticated: boolean;
    isMobile: boolean;
    allowPopoverActivation: boolean;
};

export const useNavigationUserElements = (
    params: UseNavigationUserElementsParams
): {
    navRightElements: INavRightElement[];
    navMobileMiddleElements: INavMiddleElement[];
} => {
    const {kmUrl, onLogin, onLogout, isAuthenticated, isMobile, allowPopoverActivation} = params;

    const {isPopoverActive, onPopoverClose, onHoverUserIcon} = useUserPopover();
    // For static <a href> links gtag auto-decoration (configured in init_google_tag_manager)
    // appends `_gl` on click. JS redirects below need the manual linker.
    const getKMLink = (getPath: (params: {site: SiteSlug}) => string) => getFullKMLink(kmUrl, getPath);

    const authenticatedUserNavigationField = {
        title: "Twoje Konto",
        icon: <UserIcon size={isMobile ? "2" : "2.5"} />,
        url: getKMLink(kmAppLink.site.offers.appliedWithParams),
        subElements: [
            {
                title: "Moje zapytania",
                url: getKMLink(kmAppLink.site.offers.appliedWithParams),
                target: "_blank"
            },
            {
                title: "Ustawienia konta",
                url: getKMLink(kmAppLink.site.user.baseWithParams),
                target: "_blank"
            },
            {
                title: "Wyloguj",
                onClick: onLogout
            }
        ]
    };

    const unauthenticatedUserNavigationField = {
        title: "Twoje Konto",
        rel: "nofollow",
        icon: <UserIconPopover isPopoverActive={isPopoverActive} onPopoverClose={onPopoverClose} />,
        onClick: onLogin,
        onHover: allowPopoverActivation ? onHoverUserIcon : noop
    };

    return {
        navRightElements: [isAuthenticated ? authenticatedUserNavigationField : unauthenticatedUserNavigationField],
        navMobileMiddleElements: [
            isAuthenticated
                ? {
                      ...authenticatedUserNavigationField,
                      onClick: () => {
                          if (isMobile) {
                              const kmHostname = kmUrl ? new URL(kmUrl).hostname : "";
                              window.location.href = appendAmplitudeCrossDomainParams(
                                  decorateUrlWithGaLinker(getKMLink(kmAppLink.site.offers.baseWithParams)),
                                  [kmHostname]
                              );
                          }
                      }
                  }
                : unauthenticatedUserNavigationField
        ]
    };
};
import {UserIcon} from "@pg-design/icons-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";
import {noop} from "@pg-mono/nodash";

import {UserIconPopover} from "../components/UserIconPopover";
import {INavMiddleElement, INavRightElement} from "../Navigation";
import {appendAmplitudeCrossDomainParams} from "../utils/append_amplitude_cross_domain_params";
import {decorateUrlWithGaLinker} from "../utils/decorate_url_with_ga_linker";
import {getFullKMLink} from "../utils/get_full_km_link";
import {useUserPopover} from "./use_user_popover";

export type UseNavigationUserElementsParams = {
    kmUrl: string;
    rpUrl?: string;
    onLogin: (e: React.MouseEvent<HTMLElement>) => void;
    onLogout: (e: React.MouseEvent<HTMLElement>) => void;
    isAuthenticated: boolean;
    isMobile: boolean;
    allowPopoverActivation: boolean;
};

export const useNavigationUserElements = (
    params: UseNavigationUserElementsParams
): {
    navRightElements: INavRightElement[];
    navMobileMiddleElements: INavMiddleElement[];
} => {
    const {kmUrl, onLogin, onLogout, isAuthenticated, isMobile, allowPopoverActivation} = params;

    const {isPopoverActive, onPopoverClose, onHoverUserIcon} = useUserPopover();
    // For static <a href> links gtag auto-decoration (configured in init_google_tag_manager)
    // appends `_gl` on click. JS redirects below need the manual linker.
    const getKMLink = (getPath: (params: {site: SiteSlug}) => string) => getFullKMLink(kmUrl, getPath);

    const authenticatedUserNavigationField = {
        title: "Twoje Konto",
        icon: <UserIcon size={isMobile ? "2" : "2.5"} />,
        url: getKMLink(kmAppLink.site.offers.appliedWithParams),
        subElements: [
            {
                title: "Moje zapytania",
                url: getKMLink(kmAppLink.site.offers.appliedWithParams),
                target: "_blank"
            },
            {
                title: "Ustawienia konta",
                url: getKMLink(kmAppLink.site.user.baseWithParams),
                target: "_blank"
            },
            {
                title: "Wyloguj",
                onClick: onLogout
            }
        ]
    };

    const unauthenticatedUserNavigationField = {
        title: "Twoje Konto",
        rel: "nofollow",
        icon: <UserIconPopover isPopoverActive={isPopoverActive} onPopoverClose={onPopoverClose} />,
        onClick: onLogin,
        onHover: allowPopoverActivation ? onHoverUserIcon : noop
    };

    return {
        navRightElements: [isAuthenticated ? authenticatedUserNavigationField : unauthenticatedUserNavigationField],
        navMobileMiddleElements: [
            isAuthenticated
                ? {
                      ...authenticatedUserNavigationField,
                      onClick: () => {
                          if (isMobile) {
                              const kmHostname = kmUrl ? new URL(kmUrl).hostname : "";
                              window.location.href = appendAmplitudeCrossDomainParams(
                                  decorateUrlWithGaLinker(getKMLink(kmAppLink.site.offers.baseWithParams)),
                                  [kmHostname]
                              );
                          }
                      }
                  }
                : unauthenticatedUserNavigationField
        ]
    };
};
